export const watchlistCoinList = async (list, filterInterval, quote = 'USD') => {
	try {
		const intervals = {
			'1d': '&timePeriod=24h',
			'7d': '&timePeriod=7d',
			'30d': '&timePeriod=30d',
			'365d': '&timePeriod=1y',
			ytd: '&timePeriod=5y',
		};

		const res = await fetch(
			`/api/coin-data/watchlist-coin-list?coins=${list}&interval=${intervals[filterInterval]}&quote=${quote}`,
		);
		const response = await res.json();
		return response.data;
	} catch (error) {
		console.error(error);
	}
};
